import { AfterViewInit, Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {QuestionInput} from '../question-input';
import {MatDatepicker, MatDatepickerIntl, MatDatepickerModule} from "@angular/material";

@Component({
  selector: 'app-year-month-date',
  templateUrl: './year-month-date.component.html',
  styleUrls: ['./year-month-date.component.scss']
})
export class YearMonthDateComponent extends QuestionInput implements AfterViewInit, OnInit {

  @ViewChild('inputField', {static: true})

  inputField: ElementRef;
  dateValue: Date;

  constructor(private _intl: MatDatepickerIntl,) {
    super();
  }
  ngOnInit() {
    if (this.question.answer && this.question.answer && /^\d{2}\/\d{2}\/\d{4}$/.exec(this.question.answer)) {
      this.dateValue = new Date(this.question.answer);
    }
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.questionAnswered.emit(this.question.answer != null);
    });
  }

  valueChange(value) {
    this.questionAnswered.emit(!!value);
  }


  get answer(): any {
    return (this.inputField.nativeElement as HTMLInputElement).value;
  }

  getMaxDate() {
    const currentDate = new Date();
    return new Date(currentDate.getFullYear() + 1, 11, 31);
  }

  monthSelected(event: Date, picker: MatDatepicker<Date>, input: HTMLInputElement) {
    picker.close();

    // Get the selected month and year
    const selectedMonth = event.getMonth() + 1; // Adding 1 to the month because it's 0-indexed
    const selectedYear = event.getFullYear();
  
    // Format the selected month and year as "MM/YYYY"
    const formattedDate = `${String(selectedMonth).padStart(2, '0')}/${selectedYear}`;
  
    // Update the input value with the formatted date
    input.value = formattedDate;
  
    // Emit the formatted date value if needed
    this.valueChange(formattedDate);
  }
}
